import fake from '../../fake';

export default (BASE_URL) => ({
  // GET /api/:userId/project/:projectId/media -- get all media
  loadMedia: function(userId) {
    return new Promise((res, rej) => {
      res(fake.media);
    })
  },
  // POST /api/:userId/projects/:projectId/media -- add media
  addMedia: function (userId, projectId, media) {},
  // DELETE /api/:userId/projects/:projectId/media/:mediaId -- remove media
  removeMedia: function (userId, projectId, mediaId) {},
});
